import { Path } from 'components/_hooks/use-router';
import { useLocalstoreSignOut } from 'components/app/_mediator/localstore/use-localstore-signout';

export const useAppSignOut = () => {
  const { localstoreSignOut } = useLocalstoreSignOut();
  return () => {
    localstoreSignOut();
    window.location.href = Path.auth + window.location.search;
  };
};
